import React, { useState, useEffect } from 'react'
import { CaretDownFilled } from '@ant-design/icons'
import styles from './index.module.less'

export default function Index({
  value = '',
  error = '',
  onChange = e => {},
  ...props
}: any) {
  const [selectValue, setSelectValue] = useState<any>('+86')
  const [inputValue, setInputValue] = useState<any>('')

  // 区域
  const selectChange = e => {
    setSelectValue(e.target.value)
    let changevalue = inputValue
      ? {
          areaCode: e.target.value,
          mobile: inputValue,
        }
      : ''
    onChange(changevalue)
  }

  const inputChange = e => {
    setInputValue(e.target.value)
    let changevalue = e.target.value
      ? {
          areaCode: selectValue,
          mobile: e.target.value,
        }
      : ''
    onChange(changevalue)
  }

  useEffect(() => {
    if (value) {
      setSelectValue(value.areaCode)
      setInputValue(value.mobile || '')
    }
  }, [value])

  return (
    <div className={styles.phoneInput}>
      <div className={styles.select}>
        <select value={selectValue} onChange={selectChange}>
          <option value="+86">+86</option>
          <option value="+852">+852</option>
          <option value="+853">+853</option>
          <option value="+886">+886</option>
        </select>
        <CaretDownFilled className={styles.icon} />
      </div>
      <input
        value={inputValue}
        {...props}
        onChange={inputChange}
        type="text"
        placeholder="请输入手机号码"
      />
    </div>
  )
}
